export const activeUsersTypes = ['dancers', 'judges'];

export const certificatedUsersTypes = ['dancers', 'coaches', 'clubs', 'conditions'];
